// Bloques skeleton con shimmer para estados de carga de datos (fase 2 de
// fluidez): en vez de spinner, se pinta la silueta del contenido que viene.
// Uso: <Skeleton w={120} h={16} /> · <Skeleton h={180} r={16} /> · circle para avatares.
import { useThemeColors } from '../context/ThemeContext';

let injected = false;
function injectKeyframes() {
  if (injected || typeof document === 'undefined') return;
  injected = true;
  const s = document.createElement('style');
  s.textContent = '@keyframes skShimmer { to { transform: translateX(100%); } }';
  document.head.appendChild(s);
}

export default function Skeleton({ w = '100%', h = 16, r = 8, circle = false, style }) {
  const { isDark } = useThemeColors();
  injectKeyframes();
  const size = circle ? { width: w, height: w, borderRadius: '50%' } : { width: w, height: h, borderRadius: r };
  return (
    <div style={{
      ...size,
      background: isDark ? 'rgba(255,255,255,0.055)' : 'rgba(17,24,28,0.06)',
      position: 'relative', overflow: 'hidden', flexShrink: 0,
      ...style,
    }}>
      <div style={{
        position: 'absolute', inset: 0, transform: 'translateX(-100%)',
        animation: 'skShimmer 1.4s ease-in-out infinite',
        background: `linear-gradient(90deg, transparent, ${isDark ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.65)'}, transparent)`,
      }} />
    </div>
  );
}
